import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useDebounce from "../../../layout/WelcomePage/Worksheets/useDebounce";
import { Button, Popover, Radio, Select, Tooltip } from "antd";
import WordCloudColorPalate from "../../../WidgetMaker/WordCloudColorPalate";
import isEqual from "react-fast-compare";
import { updateScreenWidgetPropdataWithClearGraphData } from "../../../../redux/actions/commandCenter/screens/screen";
import {
  callNotification,
  deepCopy,
  getPaneIndex,
} from "../../../../redux/constants";
import {
  setDefaultColorSetIndexForNetwork,
  setIsNetworkWidgetSettingEdit,
  setNetworkCommonEdgesColor,
  setNetworkEdgesHighlightColor,
  setNetworkWidgetSettingObject,
} from "../../../../redux/actions/Network";
import { DEFAULT_COLOR_SET } from "../../../../redux/constants/networkEnums";
const NetworkSettings = ({ isOpen, isSettingDisable, headerHeight }) => {
  const dispatch = useDispatch();
  const { Option } = Select;
  const [radiusOptions, setRadiusOptions] = useState(null);
  const [networkWidgetMetaData, setNetworkWidgetMetaData] = useState(null);
  const [axisSettingData, setAxisSettingData] = useState(null);
  const [previousAxisSettingData, setPreviousAxisSettingData] = useState(null);
  const debouncedAxisSettingData = useDebounce(axisSettingData, 1000);
  const [settingAppliedStatus, setSettingAppliedStatus] = useState(false);

  const [axisNodeLimitData, setAxisNodeLimitData] = useState(null);
  const debouncedAxisNodeLimitData = useDebounce(axisNodeLimitData, 500);

  const authParams = useSelector((state) => state.Authentication.authParams);
  const [minimumXAxisNodesLimit, setMinimumXAxisNodesLimit] = useState(
    authParams?.screen_id === "000-000-563" ? 1 : 1
  );
  const [maximumXAxisNodesLimit, setMaximumXAxisNodesLimit] = useState(
    authParams?.screen_id === "000-000-563" ? 50 : 50
  );

  const [minimumYAxesNodesLimit, setMinimumYAxesNodesLimit] = useState(
    authParams?.screen_id === "000-000-563" ? 1 : 1
  );
  const [maximumYAxesNodesLimit, setMaximumYAxesNodesLimit] = useState(
    authParams?.screen_id === "000-000-563" ? 100 : 100
  );
  const [networkGraphOptions, setNetworkGraphOptions] = useState(null);

  const screen = useSelector((state) => state?.Screens?.screen);
  const panes = useSelector((state) => state?.Tab1?.panes);
  const activeKey = useSelector((state) => state?.Tab1?.activeKey);

  const screenSettings = useSelector(
    (state) => state?.Screens?.screen?.settings
  );
  const widgetSettingObj = useSelector(
    (state) => state?.Network?.widgetSettingObj
  );
  const graphConditions = useSelector(
    (state) => state?.apiCall?.graphConditions
  );
  const graphConditionAggregation = useSelector(
    (state) => state?.apiCall?.graphConditions?.column_aggregations
  );
  const defaultColorSetIndex = useSelector(
    (state) => state?.Network?.defaultColorSetIndex
  );
  const [selectedColorSet, setSelectedColorSet] = useState({
    index: defaultColorSetIndex,
    value: DEFAULT_COLOR_SET?.[defaultColorSetIndex],
  });

  const commonEdgesColor = useSelector(
    (state) => state?.Network?.networkCommonEdgesColor
  );
  const edgesHighlightColor = useSelector(
    (state) => state?.Network?.networkEdgesHighlightColor
  );
  const WM_attributes = useSelector(
    (state) => state?.WidgetMaker?.WM_attributes
  );
  const allAttributes = useSelector(
    (state) => state?.attributes?.allAttributes
  );
  const All_WM_attributes = useSelector(
    (state) => state.WidgetMaker.All_WM_attributes
  );
  const allAttributesList = useMemo(() => {
    return allAttributes ? allAttributes : All_WM_attributes;
  }, [allAttributes, All_WM_attributes]);
  const getDataSourceOfThisAttribute = (attributeName) => {
    let datasource;
    let attributes = { ...WM_attributes };

    // Handle both old and new attribute structures
    if (attributes && typeof attributes === "object") {
      // First, try the old nested structure
      Object.entries(attributes)?.forEach((data_source) => {
        if (data_source?.[1] && typeof data_source[1] === "object") {
          Object.entries(data_source?.[1])?.forEach((el) => {
            if (el[1] && Array.isArray(el[1])) {
              el[1]?.forEach((g) => {
                if (
                  Array.isArray(g) &&
                  g[0]?.toLowerCase() === attributeName?.toLowerCase()
                ) {
                  datasource = graphConditions?.grp_src_map?.[data_source?.[0]];
                }
              });
            }
          });
        }
      });

      // If not found in old structure, try new direct data source structure
      if (!datasource) {
        ["common", "author", "mentions", "page", "tickets"].forEach(
          (dataSourceKey) => {
            const dataSourceValue = attributes[dataSourceKey];
            if (dataSourceValue && typeof dataSourceValue === "object") {
              Object.entries(dataSourceValue).forEach((categoryEntry) => {
                if (categoryEntry[1] && typeof categoryEntry[1] === "object") {
                  Object.entries(categoryEntry[1]).forEach((attrEntry) => {
                    if (
                      attrEntry[0]?.toLowerCase() ===
                      attributeName?.toLowerCase()
                    ) {
                      // Map the data source key to the appropriate source using grp_src_map
                      datasource =
                        graphConditions?.grp_src_map?.[dataSourceKey] ||
                        dataSourceKey;
                    }
                  });
                }
              });
            }
          }
        );
      }

      // If still not found, check allAttributesList as fallback
      if (!datasource && allAttributesList) {
        const foundInAllAttributes =
          allAttributesList[attributeName?.toLowerCase()];
        if (foundInAllAttributes) {
          // Default to 'mentions' if found in allAttributesList but no specific source determined
          datasource = "mentions";
        }
      }
    }

    return datasource;
  };
  useEffect(() => {
    if (authParams?.screen_id) {
      if (authParams?.screen_id === "000-000-563") {
        setMinimumXAxisNodesLimit(1);
        setMaximumXAxisNodesLimit(50);
        setMinimumYAxesNodesLimit(1);
        setMaximumYAxesNodesLimit(100);
      } else {
        setMinimumXAxisNodesLimit(1);
        setMaximumXAxisNodesLimit(50);
        setMinimumYAxesNodesLimit(1);
        setMaximumYAxesNodesLimit(100);
      }
    }
  }, [authParams?.screen_id]);
  useEffect(() => {
    if (
      Array.isArray(graphConditions?.["network-graph-v2"]?.int_new?.include) &&
      graphConditions?.["network-graph-v2"]?.int_new?.include?.length > 0
    ) {
      let options = graphConditions?.["network-graph-v2"]?.int_new?.include
        ?.map((attributeObj) => {
          if (attributeObj) {
            let attr = {
              attribute: attributeObj?.value,
              deep_dive_info: attributeObj?.deep_dive_info
                ? attributeObj?.deep_dive_info
                : null,
              data_source: getDataSourceOfThisAttribute(attributeObj?.value),
              trace_name: attributeObj?.text
                ? attributeObj?.text
                : allAttributesList?.[attributeObj?.value],
              aggregation: graphConditionAggregation?.avg?.includes(
                attributeObj?.value
              )
                ? "avg"
                : graphConditionAggregation?.average_attribute?.includes(
                    // For mentions attribute
                    attributeObj?.value
                  )
                ? "avg"
                : graphConditionAggregation?.count_distinct?.includes(
                    attributeObj?.value
                  )
                ? "COUNT"
                : graphConditionAggregation?.count?.includes(
                    attributeObj?.value
                  )
                ? "COUNT"
                : graphConditionAggregation?.max?.includes(attributeObj?.value)
                ? "max"
                : graphConditions?.[`latest-agg-columns`]?.includes(
                    attributeObj?.value
                  )
                ? "latest"
                : attributeObj?.value === "nss"
                ? "COUNT"
                : attributeObj?.value === "srs"
                ? "COUNT"
                : "SUM",
            };
            return attr;
          } else {
            return null;
          }
        })
        ?.filter((e) => e);
      setNetworkGraphOptions(options?.length > 0 ? options : []);
    }
  }, [graphConditions?.["network-graph-v2"]?.int_new?.include]);

  useEffect(() => {
    if (
      Array.isArray(graphConditions?.["network-graph-v2"]?.order_by?.include) &&
      graphConditions?.["network-graph-v2"]?.order_by?.include?.length > 0
    ) {
      let options = graphConditions?.["network-graph-v2"]?.order_by?.include
        ?.map((attributeObj) => {
          if (attributeObj) {
            let attr = {
              attribute: attributeObj?.value,
              trace_name:
                attributeObj?.text === "All hubs equal"
                  ? "All Equal Hubs"
                  : attributeObj?.text,
            };
            return attr;
          } else {
            return null;
          }
        })
        ?.filter((e) => e);
      setRadiusOptions(options?.length > 0 ? options : []);
    }
  }, [graphConditions?.["network-graph-v2"]?.order_by?.include]);
  useEffect(() => {
    // to set NetworkWidgetMetaData
    if (
      widgetSettingObj &&
      widgetSettingObj?.type === "dashboardWidgetSetting"
    ) {
      const paneIndex = getPaneIndex(panes, activeKey);
      const widget_metadata =
        widgetSettingObj?.sectionIndex !== null &&
        widgetSettingObj?.sectionIndex >= 0 &&
        widgetSettingObj?.widgetIndex >= 0
          ? panes[paneIndex]?.sections?.[widgetSettingObj?.sectionIndex]
              ?.widgets?.[widgetSettingObj?.widgetIndex]
          : !widgetSettingObj?.sectionIndex >= 0 &&
            widgetSettingObj?.widgetIndex >= 0
          ? panes[paneIndex]?.section?.[0]?.widgets?.[
              widgetSettingObj?.widgetIndex
            ]
          : null;
      setNetworkWidgetMetaData({ ...widget_metadata });
    } else if (
      screen &&
      Array.isArray(screen?.widgets) &&
      screen?.widgets?.length
    ) {
      // when we are using command center
      screen?.widgets?.forEach((wid, wid_index) => {
        if (wid?.widget_id) {
          setNetworkWidgetMetaData({ ...wid });
        }
      });
    }
  }, [screen, widgetSettingObj]);
  useEffect(() => {
    if (networkWidgetMetaData && !axisSettingData) {
      let updatedAxisSettingData = structuredClone(axisSettingData);
      if (networkWidgetMetaData?.x_axis) {
        updatedAxisSettingData = updatedAxisSettingData
          ? {
              ...updatedAxisSettingData,
              ["x_axis"]: { ...networkWidgetMetaData?.x_axis },
            }
          : { ["x_axis"]: { ...networkWidgetMetaData?.x_axis } };
      }
      if (networkWidgetMetaData?.y_axes) {
        updatedAxisSettingData = updatedAxisSettingData
          ? {
              ...updatedAxisSettingData,
              ["y_axes"]: [...networkWidgetMetaData?.y_axes],
            }
          : { ["y_axes"]: [...networkWidgetMetaData?.y_axes] };
      }
      if (networkWidgetMetaData?.y_series) {
        updatedAxisSettingData = updatedAxisSettingData
          ? {
              ...updatedAxisSettingData,
              ["y_series"]: [...networkWidgetMetaData?.y_series],
            }
          : { ["y_series"]: [...networkWidgetMetaData?.y_series] };
      }
      // for common and highlight color
      if (commonEdgesColor) {
        updatedAxisSettingData.commonEdgesColor = commonEdgesColor;
      }
      if (edgesHighlightColor) {
        updatedAxisSettingData.edgesHighlightColor = edgesHighlightColor;
      }

      setAxisSettingData(updatedAxisSettingData);
      setAxisNodeLimitData(updatedAxisSettingData);
      setPreviousAxisSettingData(updatedAxisSettingData);
      setSettingAppliedStatus(false);
    }
  }, [networkWidgetMetaData]);

  const handleColorStyleChange = (value, axis, nodeIndex) => {
    if (value !== "2") {
      setSettingAppliedStatus(false);
      let updatedAxisSettingData = structuredClone(axisSettingData);
      // for common and highlight color
      if (axis === "network_common_edges") {
        updatedAxisSettingData.commonEdgesColor = value
          ? value
          : commonEdgesColor;
        setAxisSettingData(updatedAxisSettingData);
      } else if (axis === "network_edges_highlight") {
        updatedAxisSettingData.edgesHighlightColor = value
          ? value
          : edgesHighlightColor;
        setAxisSettingData(updatedAxisSettingData);
      } else {
        if (axis === "x_axis") {
          updatedAxisSettingData = updatedAxisSettingData
            ? {
                ...updatedAxisSettingData,
                [axis]: { ...updatedAxisSettingData?.[axis], color: value },
              }
            : { [axis]: { color: value } };
        }
        if (axis === "y_axes") {
          let updateYAxes = [];
          if (
            nodeIndex >= 0 &&
            updatedAxisSettingData?.[axis] &&
            Array.isArray(updatedAxisSettingData?.[axis])
          ) {
            updateYAxes = structuredClone(updatedAxisSettingData?.[axis]);
            updateYAxes = updateYAxes?.map((y, i) => {
              if (i === nodeIndex) {
                y.color = value;
              }
              return y;
            });
          }
          updatedAxisSettingData = updatedAxisSettingData
            ? {
                ...updatedAxisSettingData,
                [axis]:
                  updateYAxes?.length > 0
                    ? [...updateYAxes]
                    : [...updatedAxisSettingData?.[axis]],
              }
            : { [axis]: updateYAxes?.length > 0 ? [...updateYAxes] : [] };
        }

        setAxisSettingData(updatedAxisSettingData);
      }
    }
  };
  const handleChangeNodeLimit = (value, axis, nodeIndex) => {
    setSettingAppliedStatus(false);
    if (
      !axisNodeLimitData ||
      (axisNodeLimitData &&
        axisNodeLimitData?.[axis]?.x_limit !== parseInt(value, 10))
    ) {
      let updatedAxisNodeLimitData = axisNodeLimitData;
      updatedAxisNodeLimitData.currentAxis = axis;
      updatedAxisNodeLimitData.currentNodeIndex = nodeIndex;
      if (axis === "x_axis") {
        updatedAxisNodeLimitData = axisNodeLimitData
          ? {
              ...axisNodeLimitData,
              [axis]: {
                ...axisNodeLimitData?.[axis],
                x_limit: parseInt(value, 10),
              },
            }
          : { [axis]: { x_limit: parseInt(value, 10) } };
      }
      if (axis === "y_axes") {
        let updateYAxes = [];
        if (
          nodeIndex >= 0 &&
          axisNodeLimitData?.[axis] &&
          Array.isArray(axisNodeLimitData?.[axis])
        ) {
          updateYAxes = deepCopy(axisNodeLimitData?.[axis]);
          updateYAxes = updateYAxes?.map((y, i) => {
            if (i === nodeIndex) {
              y.y_limit = parseInt(value, 10);
            }
            return y;
          });
        }
        updatedAxisNodeLimitData = axisNodeLimitData
          ? {
              ...axisNodeLimitData,
              [axis]:
                updateYAxes?.length > 0
                  ? [...updateYAxes]
                  : [...axisNodeLimitData?.[axis]],
            }
          : { [axis]: updateYAxes?.length > 0 ? [...updateYAxes] : [] };
      }
      setAxisNodeLimitData(updatedAxisNodeLimitData);
    }
  };
  const handleYSeriesAttributeChange = (value, index) => {
    let filterVal = {};
    let attributeObj =
      Array.isArray(networkGraphOptions) &&
      networkGraphOptions?.find((obj) => obj?.attribute === value);
    let updatedYseries = structuredClone(networkWidgetMetaData?.y_series);

    updatedYseries =
      Array.isArray(updatedYseries) &&
      updatedYseries?.map((series, s_index) => {
        if (index === s_index) {
          return {
            ...attributeObj,
          };
        } else {
          return series;
        }
      });
    let updatedAxisSettingData = axisSettingData;
    updatedAxisSettingData = axisSettingData
      ? {
          ...axisSettingData,
          ["y_series"]:
            updatedYseries?.length > 0
              ? [...updatedYseries]
              : [...axisSettingData?.["y_series"]],
        }
      : { ["y_series"]: updatedYseries?.length > 0 ? [...updatedYseries] : [] };
    setAxisSettingData(updatedAxisSettingData);
  };
  useEffect(() => {
    if (debouncedAxisNodeLimitData?.currentAxis) {
      if (
        debouncedAxisNodeLimitData?.currentAxis === "x_axis" &&
        debouncedAxisNodeLimitData?.x_axis?.x_limit >= minimumXAxisNodesLimit &&
        debouncedAxisNodeLimitData?.x_axis?.x_limit <= maximumXAxisNodesLimit
      ) {
        let axis = debouncedAxisNodeLimitData?.currentAxis;
        let updatedAxisSettingData = axisSettingData;
        updatedAxisSettingData = axisSettingData
          ? {
              ...axisSettingData,
              [axis]: {
                ...axisSettingData?.[axis],
                x_limit: parseInt(
                  debouncedAxisNodeLimitData?.x_axis?.x_limit,
                  10
                ),
              },
            }
          : {
              [axis]: {
                x_limit: parseInt(
                  debouncedAxisNodeLimitData?.x_axis?.x_limit,
                  10
                ),
              },
            };
        setAxisSettingData(updatedAxisSettingData);
      }
      if (debouncedAxisNodeLimitData?.currentAxis === "y_axes") {
        let yLimitChanged = false;
        let axis = debouncedAxisNodeLimitData?.currentAxis;
        let nodeIndex = debouncedAxisNodeLimitData?.currentNodeIndex;
        let updatedAxisSettingData = axisSettingData;
        let updateYAxes = [];
        if (
          nodeIndex >= 0 &&
          axisSettingData?.[axis] &&
          Array.isArray(axisSettingData?.[axis])
        ) {
          updateYAxes = deepCopy(axisSettingData?.[axis]);
          updateYAxes = updateYAxes?.map((y, i) => {
            if (
              i === nodeIndex &&
              debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit >=
                minimumYAxesNodesLimit &&
              debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit <=
                maximumYAxesNodesLimit
            ) {
              yLimitChanged = true;
              y.y_limit = parseInt(
                debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit,
                10
              );
            }
            return y;
          });
        }
        updatedAxisSettingData = axisSettingData
          ? {
              ...axisSettingData,
              [axis]:
                updateYAxes?.length > 0
                  ? [...updateYAxes]
                  : [...axisSettingData?.[axis]],
            }
          : { [axis]: updateYAxes?.length > 0 ? [...updateYAxes] : [] };
        if (yLimitChanged) setAxisSettingData(updatedAxisSettingData);
      }
    }
  }, [debouncedAxisNodeLimitData]);
  useEffect(() => {
    let xAxisIsUpdated = false,
      yAxesIsUpdated = false,
      ySeriesIsUpdated = false,
      commonEdgeColorUpdated = false,
      edgesHighlightColorUpdated = false;
    let xAxisIsValid = true,
      yAxesIsValid = true,
      ySeriesIsValid = true;
    if (
      !(
        debouncedAxisNodeLimitData?.x_axis?.x_limit >= minimumXAxisNodesLimit &&
        debouncedAxisNodeLimitData?.x_axis?.x_limit <= maximumXAxisNodesLimit
      )
    ) {
      xAxisIsValid = false;
    }
    if (
      !isEqual(
        debouncedAxisSettingData?.x_axis,
        previousAxisSettingData?.x_axis
      )
    ) {
      xAxisIsUpdated = true;
    }

    if (
      Array.isArray(debouncedAxisSettingData?.y_axes) &&
      Array.isArray(previousAxisSettingData?.y_axes)
    ) {
      for (let i = 0; i < debouncedAxisSettingData?.y_axes?.length; i++) {
        let yAxesCurrentObj = debouncedAxisSettingData?.y_axes?.[i];
        for (let j = 0; j < previousAxisSettingData?.y_axes?.length; j++) {
          let yAxesPreviousObj = previousAxisSettingData?.y_axes?.[i];
          if (
            !(
              debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit >=
                minimumYAxesNodesLimit &&
              debouncedAxisNodeLimitData?.y_axes?.[i]?.y_limit <=
                maximumYAxesNodesLimit
            )
          ) {
            yAxesIsValid = false;
          }
          if (!isEqual(yAxesCurrentObj, yAxesPreviousObj)) {
            yAxesIsUpdated = true;
            if (!yAxesIsValid) break;
          }
          if (yAxesIsUpdated && !yAxesIsValid) break;
        }
      }
    }
    if (
      Array.isArray(debouncedAxisSettingData?.y_series) &&
      Array.isArray(previousAxisSettingData?.y_series)
    ) {
      for (let i = 0; i < debouncedAxisSettingData?.y_series?.length; i++) {
        let ySeriesCurrentObj = debouncedAxisSettingData?.y_series?.[i];
        for (let j = 0; j < previousAxisSettingData?.y_series?.length; j++) {
          let ySeriesPreviousObj = previousAxisSettingData?.y_series?.[i];
          if (!isEqual(ySeriesCurrentObj, ySeriesPreviousObj)) {
            // if(){
            //   ySeriesIsValid= false;
            // }
            ySeriesIsUpdated = true;
            if (!ySeriesIsValid) break;
          }
          if (ySeriesIsUpdated && !ySeriesIsValid) break;
        }
      }
    }
    if (
      !isEqual(
        debouncedAxisSettingData?.commonEdgesColor,
        previousAxisSettingData?.commonEdgesColor
      )
    ) {
      commonEdgeColorUpdated = true;
    }
    if (
      !isEqual(
        debouncedAxisSettingData?.edgesHighlightColor,
        previousAxisSettingData?.edgesHighlightColor
      )
    ) {
      edgesHighlightColorUpdated = true;
    }
    if (
      (xAxisIsUpdated ||
        yAxesIsUpdated ||
        ySeriesIsUpdated ||
        commonEdgeColorUpdated ||
        edgesHighlightColorUpdated) &&
      xAxisIsValid &&
      yAxesIsValid &&
      ySeriesIsValid
    ) {
      setSettingAppliedStatus(true);
    } else {
      setSettingAppliedStatus(false);
    }
  }, [debouncedAxisSettingData]);
  const handleSettingApplied = () => {
    let xAxisIsUpdated = false,
      yAxesIsUpdated = false,
      ySeriesIsUpdated = false,
      commonEdgeColorUpdated = false,
      edgesHighlightColorUpdated = false;
    let xAxisIsValid = true,
      yAxesIsValid = true,
      ySeriesIsValid = true;
    if (
      !isEqual(
        debouncedAxisSettingData?.x_axis,
        previousAxisSettingData?.x_axis
      )
    ) {
      if (
        !(
          debouncedAxisSettingData?.x_axis?.x_limit >= minimumXAxisNodesLimit &&
          debouncedAxisSettingData?.x_axis?.x_limit <= maximumXAxisNodesLimit
        )
      ) {
        xAxisIsValid = false;
      }
      xAxisIsUpdated = true;
    }

    if (
      Array.isArray(debouncedAxisSettingData?.y_axes) &&
      Array.isArray(previousAxisSettingData?.y_axes)
    ) {
      for (let i = 0; i < debouncedAxisSettingData?.y_axes?.length; i++) {
        let yAxesCurrentObj = debouncedAxisSettingData?.y_axes?.[i];
        for (let j = 0; j < previousAxisSettingData?.y_axes?.length; j++) {
          let yAxesPreviousObj = previousAxisSettingData?.y_axes?.[i];
          if (!isEqual(yAxesCurrentObj, yAxesPreviousObj)) {
            if (
              !(
                debouncedAxisSettingData?.y_axes?.[i]?.y_limit >=
                  minimumYAxesNodesLimit &&
                debouncedAxisSettingData?.y_axes?.[i]?.y_limit <=
                  maximumYAxesNodesLimit
              )
            ) {
              yAxesIsValid = false;
            }
            yAxesIsUpdated = true;
            if (!yAxesIsValid) break;
          }
          if (yAxesIsUpdated && !yAxesIsValid) break;
        }
      }
    }
    if (
      Array.isArray(debouncedAxisSettingData?.y_series) &&
      Array.isArray(previousAxisSettingData?.y_series)
    ) {
      for (let i = 0; i < debouncedAxisSettingData?.y_series?.length; i++) {
        let ySeriesCurrentObj = debouncedAxisSettingData?.y_series?.[i];
        for (let j = 0; j < previousAxisSettingData?.y_series?.length; j++) {
          let ySeriesPreviousObj = previousAxisSettingData?.y_series?.[i];
          if (!isEqual(ySeriesCurrentObj, ySeriesPreviousObj)) {
            // if(){
            //   ySeriesIsValid= false;
            // }
            ySeriesIsUpdated = true;
            if (!ySeriesIsValid) break;
          }
          if (ySeriesIsUpdated && !ySeriesIsValid) break;
        }
      }
    }
    if (
      !isEqual(
        debouncedAxisSettingData?.commonEdgesColor,
        previousAxisSettingData?.commonEdgesColor
      )
    ) {
      commonEdgeColorUpdated = true;
    }
    if (
      !isEqual(
        debouncedAxisSettingData?.edgesHighlightColor,
        previousAxisSettingData?.edgesHighlightColor
      )
    ) {
      edgesHighlightColorUpdated = true;
    }
    if (
      (xAxisIsUpdated ||
        yAxesIsUpdated ||
        ySeriesIsUpdated ||
        commonEdgeColorUpdated ||
        edgesHighlightColorUpdated) &&
      xAxisIsValid &&
      yAxesIsValid &&
      ySeriesIsValid
    ) {
      let updatedPropListOfWidget = [];
      let xAxisPropValue, yAxesPropValue, ySeriesPropValue;
      if (xAxisIsUpdated && debouncedAxisSettingData?.["x_axis"]) {
        xAxisPropValue = {
          ...networkWidgetMetaData?.x_axis,
          color: debouncedAxisSettingData?.["x_axis"]?.color,
          x_limit: debouncedAxisSettingData?.["x_axis"]?.x_limit,
        };
        updatedPropListOfWidget?.push({
          prop_name: "x_axis",
          prop_value: xAxisPropValue,
        });
      }
      if (
        yAxesIsUpdated &&
        debouncedAxisSettingData?.["y_axes"] &&
        Array.isArray(debouncedAxisSettingData?.["y_axes"])
      ) {
        yAxesPropValue = [...debouncedAxisSettingData?.["y_axes"]];
        updatedPropListOfWidget?.push({
          prop_name: "y_axes",
          prop_value: yAxesPropValue,
        });
      }
      if (
        ySeriesIsUpdated &&
        debouncedAxisSettingData?.["y_series"] &&
        Array.isArray(debouncedAxisSettingData?.["y_series"])
      ) {
        yAxesPropValue = [...debouncedAxisSettingData?.["y_series"]];
        updatedPropListOfWidget?.push({
          prop_name: "y_series",
          prop_value: yAxesPropValue,
        });
      }
      if (commonEdgeColorUpdated) {
        dispatch(
          setNetworkCommonEdgesColor(debouncedAxisSettingData?.commonEdgesColor)
        );
      }
      if (edgesHighlightColorUpdated) {
        dispatch(
          setNetworkEdgesHighlightColor(
            debouncedAxisSettingData?.edgesHighlightColor
          )
        );
      }
      setPreviousAxisSettingData(debouncedAxisSettingData);
      if (updatedPropListOfWidget?.length > 0) {
        if (
          widgetSettingObj &&
          widgetSettingObj?.type === "dashboardWidgetSetting"
        ) {
          let paneIndex = getPaneIndex(panes, activeKey);

          const widget_metadata =
            widgetSettingObj?.sectionIndex !== null &&
            widgetSettingObj?.sectionIndex >= 0 &&
            widgetSettingObj?.widgetIndex >= 0
              ? panes[paneIndex]?.sections?.[widgetSettingObj?.sectionIndex]
                  ?.widgets?.[widgetSettingObj?.widgetIndex]
              : !widgetSettingObj?.sectionIndex >= 0 &&
                widgetSettingObj?.widgetIndex >= 0
              ? panes[paneIndex]?.section?.[0]?.widgets?.[
                  widgetSettingObj?.widgetIndex
                ]
              : null;
          let updatedWidgetMetaData = structuredClone(widget_metadata);
          if (
            updatedPropListOfWidget &&
            Array.isArray(updatedPropListOfWidget)
          ) {
            updatedPropListOfWidget?.forEach((propData) => {
              updatedWidgetMetaData[propData?.prop_name] = propData?.prop_value
                ? Array.isArray(propData?.prop_value)
                  ? [...propData?.prop_value]
                  : typeof propData?.prop_value === "object"
                  ? { ...propData?.prop_value }
                  : propData?.prop_value
                : propData?.prop_value;
            });
          }
          delete updatedWidgetMetaData?.graphData;
          delete updatedWidgetMetaData?.persist_graphdata;
          if (updatedWidgetMetaData) {
            let updatePanes = [...panes];
            if (
              widgetSettingObj?.sectionIndex !== null &&
              widgetSettingObj?.sectionIndex >= 0 &&
              widgetSettingObj?.widgetIndex >= 0
            ) {
              updatePanes[paneIndex].sections[
                widgetSettingObj?.sectionIndex
              ].widgets[widgetSettingObj?.widgetIndex] = updatedWidgetMetaData;
            } else if (
              !widgetSettingObj?.sectionIndex >= 0 &&
              widgetSettingObj?.widgetIndex >= 0
            ) {
              updatePanes[paneIndex].section[0].widgets[
                widgetSettingObj?.widgetIndex
              ] = updatedWidgetMetaData;
            }
            dispatch({ type: "SET_WIDGET_GRAPH_DATA", panes: updatePanes });
            dispatch(setIsNetworkWidgetSettingEdit(false));
            dispatch(setNetworkWidgetSettingObject(null));
          }
        } else {
          dispatch(
            updateScreenWidgetPropdataWithClearGraphData(
              null,
              0,
              updatedPropListOfWidget
            )
          );
        }
      }
      setSettingAppliedStatus(false);
    } else {
      callNotification("Enter valid values", "alert");
    }
  };
  const handleChangeColorSet = (index, setValue) => {
    setSelectedColorSet({ index: index, value: setValue });
    dispatch(setDefaultColorSetIndexForNetwork(index));
    if (setValue && Array.isArray(setValue)) {
      let updatedAxisSettingData = structuredClone(axisSettingData);
      // for x_axis
      updatedAxisSettingData = updatedAxisSettingData
        ? {
            ...updatedAxisSettingData,
            ["x_axis"]: {
              ...updatedAxisSettingData?.["x_axis"],
              color: setValue?.[0]?.value,
            },
          }
        : { ["x_axis"]: { color: setValue?.[0]?.value } };
      // for y_axis
      let updateYAxes = [];
      let nodeIndex = 0;
      if (
        nodeIndex >= 0 &&
        updatedAxisSettingData?.["y_axes"] &&
        Array.isArray(updatedAxisSettingData?.["y_axes"])
      ) {
        updateYAxes = structuredClone(updatedAxisSettingData?.["y_axes"]);
        updateYAxes = updateYAxes?.map((y, i) => {
          if (i === nodeIndex) {
            y.color = setValue?.[1]?.value;
          }
          return y;
        });
      }
      updatedAxisSettingData = updatedAxisSettingData
        ? {
            ...updatedAxisSettingData,
            ["y_axes"]:
              updateYAxes?.length > 0
                ? [...updateYAxes]
                : [...updatedAxisSettingData?.["y_axes"]],
          }
        : { ["y_axes"]: updateYAxes?.length > 0 ? [...updateYAxes] : [] };
      // for common and highlight color
      updatedAxisSettingData.commonEdgesColor = setValue?.[2]?.value
        ? setValue?.[2]?.value
        : commonEdgesColor;
      updatedAxisSettingData.edgesHighlightColor = setValue?.[3]?.value
        ? setValue?.[3]?.value
        : edgesHighlightColor;

      setAxisSettingData(updatedAxisSettingData);
    }
  };
  // console.log(
  //   "networkGraphOptions : ",
  //   networkGraphOptions,
  //   "allAttributesList : ",
  //   allAttributesList,
  //   "WM_attributes : ",
  //   WM_attributes,
  //   "networkWidgetMetaData : ",
  //   networkWidgetMetaData,
  //   "axisSettingData : ",
  //   axisSettingData,
  //   "selectedColorSet : ",
  //   selectedColorSet
  // );
  return (
    <>
      <div
        className="Screen__settingNetwork"
        style={{
          height: "calc(100% - " + (headerHeight ? headerHeight : 0) + "px)",
        }}
      >
        <div className={`Screen__setting ${isSettingDisable ? "disable" : ""}`}>
          <div className="Screen__setting--title">{"Default Colour Set"} </div>
          <div className="Screen__defaultColorSet">
            {DEFAULT_COLOR_SET && Array.isArray(DEFAULT_COLOR_SET) ? (
              <>
                {DEFAULT_COLOR_SET?.map((colorSet, set_index) => {
                  return (
                    <div
                      className={`Screen__defaultColorSet--set ${
                        set_index === selectedColorSet?.index ? "active" : ""
                      }`}
                      onClick={() => {
                        handleChangeColorSet(set_index, colorSet);
                      }}
                    >
                      {colorSet && Array.isArray(colorSet) ? (
                        <>
                          {colorSet?.map((c) => {
                            return (
                              <div
                                className="Screen__defaultColorSet--color"
                                style={{ backgroundColor: c?.value }}
                              ></div>
                            );
                          })}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  );
                })}
              </>
            ) : (
              ""
            )}
          </div>

          {/* Currently Hide option for changing the color, because some rerendering happing again */}
          <div className="Screen__setting--title">{"Edges"} </div>
          <div className="Screen__setting--number d-flex">
            <div className="Screen__setting--div d-flex flex-direction-row">
              <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                <div
                  className="floating-label-group header-brands"
                  style={{ flexGrow: "0.5" }}
                >
                  <WordCloudColorPalate
                    type="editField"
                    onChangeSeriesColor={(value) => {
                      handleColorStyleChange(value, "network_edges_highlight");
                    }}
                    seriesColor={
                      axisSettingData?.edgesHighlightColor
                        ? axisSettingData?.edgesHighlightColor
                        : edgesHighlightColor
                        ? edgesHighlightColor
                        : null
                    }
                  />
                  <label
                    className="portlet-label floating-label bg__white font-size12"
                    style={{ top: "-0.8rem" }}
                  >
                    Select Mode Colour
                  </label>
                </div>
              </div>
              <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                <div
                  className="floating-label-group header-brands"
                  style={{ flexGrow: "0.5" }}
                >
                  <WordCloudColorPalate
                    type="editField"
                    onChangeSeriesColor={(value) => {
                      handleColorStyleChange(value, "network_common_edges");
                    }}
                    seriesColor={
                      axisSettingData?.commonEdgesColor
                        ? axisSettingData?.commonEdgesColor
                        : commonEdgesColor
                        ? commonEdgesColor
                        : null
                    }
                  />
                  <label
                    className="portlet-label floating-label bg__white font-size12"
                    style={{ top: "-0.8rem" }}
                  >
                    Common Edges Colour
                  </label>
                </div>
              </div>
            </div>
          </div>

          {networkWidgetMetaData?.x_axis ? (
            <>
              <div className="Screen__setting--title">
                {networkWidgetMetaData?.x_axis?.trace_name ||
                  allAttributesList?.[
                    networkWidgetMetaData?.x_axis?.attribute
                  ]}{" "}
              </div>
              <div className="Screen__setting--number d-flex">
                <div className="Screen__setting--div d-flex flex-direction-row">
                  <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                    <div
                      className="floating-label-group header-brands"
                      style={{ flexGrow: "0.5" }}
                    >
                      <WordCloudColorPalate
                        type="editField"
                        onChangeSeriesColor={(value) => {
                          handleColorStyleChange(value, "x_axis");
                        }}
                        seriesColor={
                          axisSettingData?.x_axis?.color
                            ? axisSettingData?.x_axis?.color
                            : networkWidgetMetaData?.x_axis?.color
                            ? networkWidgetMetaData?.x_axis?.color
                            : null
                        }
                      />
                      <label
                        className="portlet-label floating-label bg__white font-size12"
                        style={{ top: "-0.8rem" }}
                      >
                        Node Colour
                      </label>
                    </div>
                  </div>
                  <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                    <div
                      className="floating-label-group header-brands "
                      style={{ flexGrow: "0.5" }}
                    >
                      <input
                        type="number"
                        id="number_of_words_x_axis"
                        className="Screen__setting--numInput"
                        min={minimumXAxisNodesLimit}
                        max={maximumXAxisNodesLimit}
                        value={axisNodeLimitData?.x_axis?.x_limit}
                        onChange={(e) => {
                          if (e?.target) {
                            e.target.value = e?.target?.value?.replace(
                              /^0/,
                              ""
                            );
                          }
                          handleChangeNodeLimit(e?.target?.value, "x_axis");
                        }}
                      />
                      <label
                        className="portlet-label floating-label bg__white font-size12"
                        style={{ top: "-0.8rem" }}
                        for={"number_of_words_x_axis"}
                      >
                        Number of nodes
                      </label>
                    </div>
                    <div
                      className={`Screen__defaultMessage ${
                        (axisNodeLimitData?.x_axis?.x_limit
                          ? axisNodeLimitData?.x_axis?.x_limit
                          : 0) >= minimumXAxisNodesLimit &&
                        (axisNodeLimitData?.x_axis?.x_limit
                          ? axisNodeLimitData?.x_axis?.x_limit
                          : 0) <= maximumXAxisNodesLimit
                          ? ""
                          : "Screen__errorMessage"
                      }`}
                    >
                      {`Enter a number between ${minimumXAxisNodesLimit} and ${maximumXAxisNodesLimit}.`}
                    </div>
                  </div>

                  <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                    <div
                      className="floating-label-group header-brands "
                      style={{ flexGrow: "0.5" }}
                    >
                      {networkGraphOptions &&
                      networkGraphOptions?.length > 0 ? (
                        <Select
                          className="w-100"
                          onChange={(value) => {
                            handleYSeriesAttributeChange(value, 0);
                          }}
                          popupClassName={`select__dropDown ${
                            authParams?.theme_type === "1"
                              ? "darkTheme"
                              : "lightTheme"
                          } `}
                          placeholder={"Select Series"}
                          value={
                            axisSettingData?.y_series?.[0]?.attribute
                              ? axisSettingData?.y_series?.[0]?.attribute
                              : networkWidgetMetaData?.y_series?.[0]?.attribute
                              ? networkWidgetMetaData?.y_series?.[0]?.attribute
                              : null
                          }
                        >
                          {networkGraphOptions
                            ?.map((op) => {
                              if (
                                networkWidgetMetaData?.x_axis?.attribute &&
                                graphConditions?.["network-graph-v2"]?.int
                                  ?.exclude?.[
                                  networkWidgetMetaData?.x_axis?.attribute?.toLowerCase()
                                ]
                                  ? !graphConditions?.[
                                      "network-graph-v2"
                                    ]?.int?.exclude?.[
                                      networkWidgetMetaData?.x_axis?.attribute?.toLowerCase()
                                    ]?.includes(op?.attribute)
                                  : true
                              ) {
                                return (
                                  <Option value={op?.attribute}>
                                    {op?.trace_name ||
                                      allAttributesList?.[op?.attribute]}
                                  </Option>
                                );
                              } else {
                                return null;
                              }
                            })
                            ?.filter((e) => e)}
                        </Select>
                      ) : (
                        ""
                      )}
                      <label
                        className="portlet-label floating-label bg__white font-size12"
                        style={{ top: "-0.8rem" }}
                        for={"number_of_words_x_axis"}
                      >
                        Based On
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          {networkWidgetMetaData?.y_axes &&
          Array.isArray(networkWidgetMetaData?.y_axes) ? (
            <>
              {networkWidgetMetaData?.y_axes?.map((el, i) => {
                return (
                  <>
                    <div className="Screen__setting--title">
                      {el?.trace_name || allAttributesList?.[el?.attribute]}{" "}
                    </div>
                    <div className="Screen__setting--number d-flex">
                      <div className="Screen__setting--div d-flex flex-direction-row">
                        <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                          <div
                            className="floating-label-group header-brands"
                            style={{ flexGrow: "0.5" }}
                          >
                            <WordCloudColorPalate
                              type="editField"
                              onChangeSeriesColor={(value) => {
                                handleColorStyleChange(value, "y_axes", i);
                              }}
                              seriesColor={
                                axisSettingData?.y_axes?.[i]?.color
                                  ? axisSettingData?.y_axes?.[i]?.color
                                  : el?.color
                                  ? el?.color
                                  : null
                              }
                            />
                            <label
                              className="portlet-label floating-label bg__white font-size12"
                              style={{ top: "-0.8rem" }}
                            >
                              Node Colour
                            </label>
                          </div>
                        </div>
                        <div className="Screen__setting--div d-flex flex-direction-column mb-15">
                          <div
                            className="floating-label-group header-brands "
                            style={{ flexGrow: "0.5" }}
                          >
                            <input
                              type="number"
                              id={`number_of_words_y_axes_${i}`}
                              className="Screen__setting--numInput"
                              min={minimumYAxesNodesLimit}
                              max={maximumYAxesNodesLimit}
                              value={axisNodeLimitData?.y_axes?.[i]?.y_limit}
                              onChange={(e) => {
                                if (e?.target) {
                                  e.target.value = e?.target?.value?.replace(
                                    /^0/,
                                    ""
                                  );
                                }
                                handleChangeNodeLimit(
                                  e?.target?.value,
                                  "y_axes",
                                  i
                                );
                              }}
                            />
                            <label
                              className="portlet-label floating-label bg__white font-size12"
                              style={{ top: "-0.8rem" }}
                              for={`number_of_words_y_axes_${i}`}
                            >
                              Number of nodes
                            </label>
                          </div>
                          <div
                            className={`Screen__defaultMessage ${
                              (axisNodeLimitData?.y_axes?.[i]?.y_limit
                                ? axisNodeLimitData?.y_axes?.[i]?.y_limit
                                : 0) >= minimumYAxesNodesLimit &&
                              (axisNodeLimitData?.y_axes?.[i]?.y_limit
                                ? axisNodeLimitData?.y_axes?.[i]?.y_limit
                                : 0) <= maximumYAxesNodesLimit
                                ? ""
                                : "Screen__errorMessage"
                            }`}
                          >
                            {`Enter a number between ${minimumYAxesNodesLimit} and ${maximumYAxesNodesLimit}.`}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </>
          ) : (
            ""
          )}
        </div>
        <div className="Screen__settingFooter">
          <Button
            disabled={!settingAppliedStatus}
            onClick={() => handleSettingApplied()}
            className="ant-btn-primary_blue"
            type="primary"
          >
            Apply
          </Button>
        </div>
      </div>
    </>
  );
};
export default React.memo(NetworkSettings, isEqual);
